var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#D6F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9997 28.3333V33M32.9997 37.6667H33.0113M44.6663 33C44.6663 39.4433 39.443 44.6667 32.9997 44.6667C26.5564 44.6667 21.333 39.4433 21.333 33C21.333 26.5567 26.5564 21.3333 32.9997 21.3333C39.443 21.3333 44.6663 26.5567 44.6663 33Z",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#EBFBFB",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIcon);
export default __webpack_public_path__ + "static/media/verification-icon.3e3e1b09743ad1cfa41c9a6cc32ef54d.svg";
export { ForwardRef as ReactComponent };